import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { icon } from '../icons';
import type { RecapArticle } from '../types';

@customElement('sarah-recap-articles')
export class SarahRecapArticles extends LitElement {
  static styles = [
    tokens,
    css`
      :host {
        display: block;
        font-family: var(--sarah-font-body);
        color: var(--sarah-text);
      }

      .theme { margin: 8px 0; }
      .theme a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 14px;
        background: #f5f3ed;
        border-radius: 8px;
        text-decoration: none;
        color: var(--sarah-bleu);
        font-weight: 600;
        transition: background-color .2s;
      }
      .theme a:hover { background: #ece8db; }
      .arrow {
        display: inline-flex;
        align-items: center;
        width: 20px;
        height: 20px;
        color: var(--sarah-rose);
        flex-shrink: 0;
      }
      .arrow svg { width: 100%; height: 100%; }
    `,
  ];

  @property({ type: Array }) articles: RecapArticle[] = [];

  render() {
    if (!this.articles.length) return nothing;
    return html`
      ${this.articles.map(
        (a) => html`
          <div class="theme">
            <a href=${a.article} target="_blank" rel="noopener" title=${a.titre}>
              <span>${a.titre}</span>
              <span class="arrow">${icon.arrowForward()}</span>
            </a>
          </div>
        `,
      )}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-recap-articles': SarahRecapArticles;
  }
}
